import React from "react";
import OurProfessionals from "../../Components/Common/OurProfessionals";
import WhatWeProvide from "../../Components/Common/WhatWeProvide";
import DiscoverTheUtlitmate from "../../Components/Common/DiscoverTheUtlitmate";
import BookYourService from "../../Components/Common/BookYourService";
import SimpleBanner from "../Common/SimpleBanner";
import AboutUs_banner from '../../Assets/home/BannerImage.png'
import SpaTreatmentsWithPricing from "../../Components/Home/SpaTreatmentsWithPricing";
import GetToKnow from "../../Components/Home/GetToknow"
import WhatTheySay from "../../Components/Home/WhatTheySay"

const About = () => {
  return (
    <div className="overflow-hidden">
      <SimpleBanner
        image={AboutUs_banner}
        name="About"
        path="Home >> About"
      />
      <DiscoverTheUtlitmate />
      <WhatWeProvide />
      <GetToKnow />
      <SpaTreatmentsWithPricing />
      <OurProfessionals />
      <WhatTheySay />
      <BookYourService />
    </div>
  );
};

export default About;
